import React, { ReactElement, ReactNode } from 'react';
import './TaskMessage.scss';

interface TaskMessageProps {
    icon: ReactNode;
    content: ReactNode;
    className?: string;
}

const TaskMessage = ({ icon, content, className = '' }: TaskMessageProps): ReactElement => {
    return (
        <div className={`task-message ${className}`}>
            <div className="task-message-icon">
                {icon}
            </div>
            <div className="task-message-content">
                {content}
            </div>
        </div>
    );
};

export default TaskMessage;